module.exports = __webpack_public_path__ + "static/media/m.1a59f652.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/m.svg
// module id = 230
// module chunks = 0